<template>
  <div class="add-to-bag" data-testid="add-to-bag">
    <Button width="full" @click="handleAddToBag">
      {{ buttonText }}
    </Button>
  </div>
</template>

<script>
import Button from "@/components/ButtonV3.vue";
import { mapGetters, mapState, mapActions } from "vuex";

export default {
  name: "AddToBag",
  components: {
    Button,
  },
  data() {
    return {
      isVariantAddedToBag: false,
    };
  },
  computed: {
    ...mapState("product", ["selectedVariant", "product"]),
    ...mapGetters("product", [
      "variant",
      "preOrder",
      "sellingPlanAllocation",
      "availableForPreOrder",
    ]),
    availableForSale() {
      if (!this.selectedVariant || this.availableForPreOrder) {
        return true;
      }

      return (
        this.selectedVariant?.quantityAvailable > 0 &&
        this.selectedVariant.availableForSale
      );
    },
    buttonText() {
      const states = {
        notSelected: !this.selectedVariant,
        selectedVariant: this.selectedVariant && this.availableForSale,
        addedToBag: this.isVariantAddedToBag,
        preOrder: this.availableForSale && this.availableForPreOrder,
        outOfStock: this.selectedVariant && !this.availableForSale,
      };

      const messages = {
        selectSize: "SELECT SIZE",
        addToBag: "ADD TO BAG",
        addedToBag: "ADDED TO BAG",
        preOrder: "PRE-ORDER",
        outOfStock: "NOTIFY ME WHEN AVAILABLE",
      };

      switch (true) {
        case states.notSelected:
          return messages.selectSize;
        case states.preOrder:
          return messages.preOrder;
        case states.addedToBag:
          return messages.addedToBag;
        case states.selectedVariant:
          return messages.addToBag;
        case states.outOfStock:
          return messages.outOfStock;
        default:
          return "";
      }
    },
  },
  methods: {
    ...mapActions("cart", ["addCartItem", "setCartOpen"]),
    ...mapActions("add-to-bag", ["showCompactStockNotif"]),
    handleAddToBag() {
      if (!this.selectedVariant) {
        return;
      }

      if (!this.availableForSale && !this.availableForPreOrder) {
        return this.showCompactStockNotif({
          product: this.product,
          variant: this.selectedVariant,
          show: true,
        });
      }

      this.isVariantAddedToBag = true;

      this.addCartItem({
        productId: this.product.id,
        variantId: this.selectedVariant.id,
        quantity: 1,
        ...(this.availableForPreOrder && {
          attributes: [
            {
              key: "_sellingPlanName",
              value: this.sellingPlanAllocation?.sellingPlan?.name,
            },
          ],
          sellingPlanId: this.preOrder.sellingPlanId,
        }),
      });

      setTimeout(() => {
        this.isVariantAddedToBag = false;
      }, 1000);

      this.setCartOpen(true);
    },
  },
};
</script>

<style lang="scss" scoped>
.add-to-bag {
  margin-bottom: 8px;
}
</style>
